import styled from 'styled-components';
import {
  FormLabel,
  FormLabelTypeMap,
  IconButton as MUIIconButton,
  Grid,
} from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

export const Header = styled(Grid)`
  margin-bottom: 5px;
`;

export const Label: OverridableComponent<FormLabelTypeMap> = styled(FormLabel)`
  ${({
    theme: {
      typography: { pxToRem },
      palette,
    },
  }) => `
    color: ${palette.text.primary};
    font-size: ${pxToRem(16)}; 
    line-height: ${pxToRem(26)}; 
    font-weight: 600;
  `}
`;

export const IconButton = styled(MUIIconButton)`
  ${({
    theme: {
      typography: { pxToRem },
    },
  }) => `
    padding: 3px;
    margin-right: 8px;
    svg {
      font-size: ${pxToRem(20)};
    }
  `}
`;
